import React from 'react';

/**
 * Inline help icon with a hover tooltip.
 * Usage: <Tooltip text="Helpful explanation" />
 */
export default function Tooltip({ text }) {
  return (
    <span className="tooltip-wrapper">
      <span className="tooltip-icon">?</span>
      <span className="tooltip-bubble">{text}</span>
    </span>
  );
}
